(function(){
  var preloaded = new WeakSet();
  function preload(nav){
    if(preloaded.has(nav)) return; preloaded.add(nav);
    nav.dataset.srcs.split('|').forEach(function(s){ var im=new Image(); im.src=s; });
  }
  document.addEventListener('mouseover', function(e){
    var nav = e.target.closest && e.target.closest('.pc-media') && e.target.closest('.pc-media').querySelector('.pc-nav');
    if(nav) preload(nav);
  });
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.pc-btn');
    if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var nav = b.parentNode, srcs = nav.dataset.srcs.split('|');
    var i = parseInt(nav.dataset.i || '0', 10);
    i = (i + (b.classList.contains('pc-next') ? 1 : -1) + srcs.length) % srcs.length;
    nav.dataset.i = i;
    var img = nav.parentNode.querySelector('.ph img');
    if(!img) return;
    img.removeAttribute('srcset'); img.removeAttribute('sizes');
    img.src = srcs[i];
  });
})();
